import {getBearer} from "../functions/getBearer";
import axios from "axios";
import {getApiLink} from "../functions/getApiLink";
import { setSummaryEmployees } from "../storage/toolkit";
import { GetAccessToken } from "./GetAccessToken";
import { Dispatch, SetStateAction } from "react";

export const SetSummaryEmployees = async (dispatch: any, month?: number, year?: number, projectId?: string, setIsLoading?: Dispatch<SetStateAction<boolean>>) => {
    const date = new Date()

    month = month ?? date.getMonth()+1
    year = year && isNaN(year) ? date.getFullYear() : !year ? date.getFullYear() : year
    projectId = projectId ?? ""

    getBearer('get')
    await axios.get(getApiLink(`/api/timesheet/employees/?month=${month}&year=${year}${projectId && "&project_id=" + projectId}`)).then(({data}) => {
        dispatch(setSummaryEmployees(data))
        setIsLoading && setIsLoading(false)
    }).catch(er => {
        er?.response?.status === 401 && GetAccessToken(dispatch, SetSummaryEmployees)
        setIsLoading && setIsLoading(false)
    })
}